export enum SnackbarType {
  Danger = 'btn-danger',
  Success = 'btn-success',
  Warn = 'btn-warning'
}
